<template>
  <article class="tk-product-menu-container">
    <!-- Component -->

    <div class="component-wrapper">
      <slot name="menu"></slot>
    </div>
    <!-- Navigation buttons and Price summary -->

    <slot name="buttons"></slot>
  </article>
</template>

<script>
export default {
  name: "ActiveProductMenuWrapper",
};
</script>

<style lang="scss" scoped>
.component-wrapper {
  ::v-deep .menu-container {
    width: 100%;
  }
}
</style>
